import { animate, inView, stagger } from "motion";
import { gsap } from "gsap";
import Swiper from "swiper";
import { A11y, Autoplay, Navigation } from "swiper/modules";
import { isTouchDevice } from "@common/util";

document.querySelectorAll(".element-usergroups").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, Navigation],
    // autoplay: {
    //   delay: 4000,
    //   pauseOnMouseEnter: true,
    // },
    loop: true,
    speed: 500,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    slidesPerView: 1,
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  });

  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    if (window.matchMedia("(min-width: 1280px)").matches) {
      const oddSlides = el.querySelectorAll(".user-group-slide.is-odd");

      inView(
        el,
        () => {
          animate(
            oddSlides,
            { y: -96 },
            {
              duration: 0.8,
              delay: stagger(0.4),
            },
          );
        },
        {
          margin: "0px 0px -25% 0px",
        },
      );
    }
  }
});

const handleUserGroupSlideTouch = (e) => {
  const slide = e.currentTarget.closest(".user-group-slide");

  if (slide.classList.contains("is-active")) {
    handleUserGroupSlideLeave(e);
  } else {
    handleUserGroupSlideEnter(e);
  }
};

const handleUserGroupSlideEnter = (e) => {
  const slide = e.currentTarget;
  const details = slide.querySelector(".user-group-details");

  slide.classList.add("is-active");

  gsap.timeline().to(details, { marginBottom: 0 });
};

const handleUserGroupSlideLeave = (e) => {
  const slide = e.currentTarget;
  const details = slide.querySelector(".user-group-details");

  slide.classList.remove("is-active");

  gsap.timeline().to(details, { marginBottom: details.offsetHeight * -1 });
};

const init = () => {
  document.querySelectorAll(".element-usergroups .user-group-slide").forEach((slide) => {
    const details = slide.querySelector(".user-group-details");

    details.style.marginBottom = `${details.offsetHeight * -1}px`;

    if (isTouchDevice) {
      slide.removeEventListener("touchend", handleUserGroupSlideTouch);
      slide.addEventListener("touchend", handleUserGroupSlideTouch);
    } else {
      slide.removeEventListener("mouseenter", handleUserGroupSlideEnter);
      slide.addEventListener("mouseenter", handleUserGroupSlideEnter);

      slide.removeEventListener("mouseleave", handleUserGroupSlideLeave);
      slide.addEventListener("mouseleave", handleUserGroupSlideLeave);
    }
  });
};

window.addEventListener("resize", init);

document.addEventListener("DOMContentLoaded", () => {
  init();
});
